// extracted by mini-css-extract-plugin
export default {"sortDropdown":"Single_sortDropdown__yROuc","option":"Single_option__0p2Wn","optionActive":"Single_optionActive__5lHfn"};